<script>
 
    import { createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();
    let toggle = () => { dispatch('isSuccess', true);};
</script>


    <div class="alert alert-success" role="alert">
        Your card has been successfully linked. To nominate another card please <strong style="cursor:pointer"  on:click={toggle} >click here</strong>.<br/><br/>You are now enrolled in Super Booster and you now have access to the Super Booster portal where you can check your rewards balance and transaction history. You will soon be receiving an email from no-reply@rewardsandexperiences.com allowing you to choose a password to log into the portal. Please check your junk folder if you do not receive this email within 10 minutes.
    </div>

